import { create } from 'zustand';

const usePaginationStore = create((set, get) => ({
    data: [],
    page: 1,
    limit: 10,

    setData: (data) => set({ data, page: 1 }),
    setPage: (page) => set({ page }),
    setLimit: (limit) => set({ limit, page: 1 }),
    total: () => get().data.length,

    editItem: (id, newObject) => {
        let updated;
        set((state) => {
            updated = state.data.map((it) => (it.id === id ? newObject : it));
            return { data: updated };
        });
    },

    deleteItem: (id) => {
        set({ data: get().data.filter((item) => item.id !== id) });
    },
}));

export default usePaginationStore;
